import { z } from 'zod';

/**
 * The web login form's shape. Messages are injected rather than imported so the
 * schema stays free of the i18n instance and can be built inside a component
 * that already has `t`.
 */
export function createFormSchema(messages: { invalidEmail: string; passwordRequired: string }) {
  return z.object({
    email: z.string().email({ message: messages.invalidEmail }),
    password: z.string().min(1, { message: messages.passwordRequired }),
    rememberMe: z.boolean(),
  });
}

export type LoginFormData = z.infer<ReturnType<typeof createFormSchema>>;
